import React from "react";
import "../styles/ExtraStyles.css";

const Loading = () => {
    return (
        <div className="loading-container">
            <div className="loading-spinner"></div>
            <p className="loading-text">Laster inn bær... 🍓</p>
        </div>
    );
};

export default Loading;
